import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './store/mutations'
import actions from './store/actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    results: [],
    isSearched: false,
    searching: false,
    upperShow: false,
    overAllSearching: false,
  },
  mutations,
  actions,
})
